module.exports = __webpack_public_path__ + "img/hkstp.ae687880.jpg";